import Head from "next/head";

export const CanonicalLink = ({ path }: { path: string }) => {
  // The server adds a trailing slash on all pages except the homepage
  const finalPath = path === "" ? path : `${path}/`;
  const fullUrl = `https://dev.blues.io${finalPath}`;

  return (
    <Head>
      <link rel="canonical" href={fullUrl} key="canonical" />
    </Head>
  );
};
